import dayjs, { Dayjs } from "dayjs";
import { appInsights } from "us.helper";

/**
 * @function
 * @description - To get the ISO8601 representation of the date
 * @param {(Dayjs | string | undefined)} date - date in either type Dayjs, string or undefined
 * @return {*}  {(string | null)} - ISO8601 representation of the date if it's a valid date
 */
export const getISODateString = (date: Dayjs | string | undefined): string | null => {
  try {
    if (!date) {
      return null;
    } else if (dayjs.isDayjs(date)) {
      return date.utc().format();
    } else if (typeof date === "string" && dayjs(date).isValid()) {
      return dayjs(date).utc().format();
    } else {
      return null;
    }
  } catch (error) {
    appInsights.trackException(`Error in add BMD getISODateString function. - ${error}`);
    return null;
  }
};
